import { EstadosAlmacenesArticulos, EstadosArticulo, TipoArticulo } from "src/gql/schema"
import { FilterSortState } from ".."
import { TODOS_ALMACEN_FILTER } from "../constants/mosaic-filters"

export const resolveAlmacenId = ({
    filterSortState,
    almacenSelected,
    almacenes,
}: {
    filterSortState?: FilterSortState
    almacenSelected: string
    almacenes: string[]
}): string[] => {
    const almacenFilters = filterSortState?.almacenFilters?.filter((f) => f.filter.length) ?? []

    if (almacenFilters.length) {
        return almacenFilters.map((f) => f.filter)
    }

    if (almacenSelected === TODOS_ALMACEN_FILTER.label) {
        return almacenes
    }

    return [almacenSelected]
}

export const resolveTipoArticulo = ({
    filterSortState,
}: {
    filterSortState?: FilterSortState
}): TipoArticulo[] => {
    const tipoFilters = filterSortState?.tipoFilters?.filter((t) => t.filter) ?? []

    if (tipoFilters.length) {
        return tipoFilters.map((t) => t.filter.toLowerCase() as TipoArticulo)
    }

    return [TipoArticulo.Insumo, TipoArticulo.Proceso, TipoArticulo.Venta]
}

export const resolveDisponibilidadFilters = ({
    filterSortState,
}: {
    filterSortState?: FilterSortState
}): {
    filterEstadoArticulo?: EstadosArticulo
    filterEstadoAlmacenArticulo?: EstadosAlmacenesArticulos[]
} => {
    const filters = filterSortState?.disponibilidadFilters?.filter((f) => f.filter.length) ?? []

    if (!filters.length) {
        return {
            filterEstadoArticulo: undefined,
            filterEstadoAlmacenArticulo: undefined,
        }
    }

    const almacenEstados: EstadosAlmacenesArticulos[] = []
    let articuloEstado: EstadosArticulo | undefined = undefined

    filters.forEach((f) => {
        if (f.filter === EstadosArticulo.Activado || f.filter === EstadosArticulo.Desactivado) {
            articuloEstado = f.filter as EstadosArticulo
        } else {
            almacenEstados.push(f.filter as EstadosAlmacenesArticulos)
        }
    })

    return {
        filterEstadoArticulo: articuloEstado,
        filterEstadoAlmacenArticulo: almacenEstados.length ? almacenEstados : undefined,
    }
}
